export const languages = { en: "English", fr: "Français", es: "Espagnol" };

export const company = {
  name: "Fab Form Industries Ltd.",
  phone: "888-303-3278",
  localPhone: "604-596-3278",
  email: "info@fab-form.com",
  findDealer: "Dealer Finder",
  copyright: `${new Date().getFullYear()} © Fab-Form Industries Ltd.`,
  stocks: "9,174,507",
  stocksDate: "22 December 2022",
  stockHigh: "2.17",
  map: "https://goo.gl/maps/bzsrkNJzGhgbeoBD7",
  address: "#19, 1610 Derwent Way, Delta BC V3M 6W1",
  title: "Fab Form Industries - Timing The Ground",
  workdays: "Mon–Fri: 8am–6pm",
  closed: "Sat, Sun: Closed",
  shop: "https://shop.fab-form.com/",
};